// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_count_notrecommended.php
// This is a query-phase stub; actual filtering happens in the post rule.
// The query phase just selects the community poll data for post-processing.
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_count_notrecommended',
	pre: function(rule, config, filter, data, query) {
		query.select('g.game_players_community', 'pc')
	},
	match: function(rule, config, filter, data, query) {},
	min: function(rule, config, filter, data, query) {},
	max: function(rule, config, filter, data, query) {},
	range: function(rule, config, filter, data, query) {},
	tolerance: function(rule, config, filter, data, query) {}
})
